module.exports = __webpack_public_path__ + "static/media/x.ecc099ed.svg";